/**
 * Downloads the content as file
 * @param {String} content Content to download
 * @param {String} filename Filename of the downloaded file
 * @param {String} mimeType Media Type / MIME-Type of the downloaded file
 */
export const downloadStringAsFile = function (content, filename, mimeType = 'text/plain') {
  const blob = new Blob([content], { type: mimeType });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  }

  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  if (link.download !== undefined) {
    link.href = url;
    link.download = filename;
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  URL.revokeObjectURL(url);
}

/**
 * Simple convert of an Array to csv/text.
 * If a robust converting is required, this is not the right method for this.
 * In this case we should add a dedicated package and replace the body of this method.
 * @param {Object[]} arr Object Array to convert to csv
 * @param {String} delimiter Field Delimiter, default ;
 * @param {String[]} headers Header overwrite if only specific fields should be exported
 */
export const convertObjectArrayToCsv = function (arr, delimiter = ';', headers = null) {
  if (arr?.length < 1) return '';

  if (headers === null) {
    const headerSet = new Set();
    arr.forEach(i => Object.keys(i).map(h => headerSet.add(h)));
    headers = Array.from(headerSet).sort();
  }

  const csvRows = [
    headers.join(delimiter),
    ...arr.map((row) =>
      headers
        .map((field) => JSON.stringify(row[field] ?? ''))
        .join(delimiter)
    )
  ];

  return csvRows.join('\n');
}

export default { downloadStringAsFile, convertObjectArrayToCsv }
